import React from "react";
// import { IconButton } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";

const Pagination = ({ page, rowsPerPage, count, onPageChange }) => {
  const validRowsPerPage = rowsPerPage > 0 ? rowsPerPage : 1;
  const validCount = count >= 0 ? count : 0;
  const totalPages = Math.ceil(validCount / validRowsPerPage);
  const range = 1;

  const handlePrev = () => page > 0 && onPageChange(null, page - 1);
  const handleNext = () =>
    page < totalPages - 1 && onPageChange(null, page + 1);

  const getPageNumbers = () => {
    const pages = [];
    const start = Math.max(0, page - range);
    const end = Math.min(totalPages - 1, page + range);

    if (start > 0) pages.push(0);
    if (start > 1) pages.push("...");

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 2) pages.push("...");
    if (end < totalPages - 1) pages.push(totalPages - 1);

    return pages;
  };
  const pageNumbers = getPageNumbers();
  const isMobileView = window.innerWidth <= 768;

  return (
    <div
      className="pagination-container"
      style={{
        display: "flex",
        flexDirection: isMobileView ? "row" : "row",
        alignItems: "center",
        gap: isMobileView ? "15px" : "8px",
        marginTop: "15px",
      }}
    >
      {/* Prev button */}
      <IconButton onClick={handlePrev} disabled={page === 0}>
        <DoubleArrowIcon sx={{ transform: "rotate(180deg)" }} />
        <span
          style={{
            fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
            fontSize: "24px",
          }}
        >
          Prev
        </span>
      </IconButton>

      {/* Page numbers and current page for mobile view */}
      {!isMobileView ? (
        <div style={{ display: "flex", gap: "8px", height: "30px" }}>
          {pageNumbers.map((pageIndex, idx) => (
            <button
              key={idx}
              style={{
                minWidth: "32px",
                backgroundColor: page === pageIndex ? "#1976d2" : "#fff",
                color: page === pageIndex ? "#fff" : "#1976d2",
                border: "2px solid #1976d2",
                cursor: "pointer",
                borderRadius: "4px",
                padding: "0 8px",
              }}
              onClick={() => {
                if (typeof pageIndex === "number") {
                  onPageChange(null, pageIndex);
                }
              }}
              disabled={typeof pageIndex !== "number"}
            >
              {pageIndex === "..." ? "..." : pageIndex + 1}
            </button>
          ))}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            margin: "10px 0",
          }}
        >
          {/* Display only the current page number in mobile view */}
          <button
            style={{
              minWidth: "32px",
              backgroundColor: "#1976d2",
              color: "#fff",
              border: "2px solid #1976d2",
              cursor: "pointer",
              borderRadius: "4px",
              padding: "0 8px",
            }}
          >
            {page + 1}
          </button>

          {/* Display "..." if there are more pages available */}
          {page < totalPages - 1 && (
            <button
              style={{
                minWidth: "30px",
                backgroundColor: "#1976d2",
                color: "#fff",
                border: "2px solid #1976d2",
                cursor: "pointer",
                borderRadius: "4px",
                padding: "0 8px",
                marginLeft: "5px",
              }}
              onClick={handleNext}
            >
              ...
            </button>
          )}
        </div>
      )}

      {/* Next button */}
      <IconButton onClick={handleNext} disabled={page === totalPages - 1}>
        <span
          style={{
            fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
            fontSize: "24px",
          }}
        >
          Next
        </span>
        <DoubleArrowIcon />
      </IconButton>
    </div>
  );
};

export default Pagination;
